import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { Delete, Check } from "@material-ui/icons";
import axios from "axios";
import Cookies from "universal-cookie";
const cookies = new Cookies();

export default class ComputeOt extends Component {
  constructor(props) {
    super();
    this.state = {
      showComputeModal: false,
      disableCompute: false,
      updated_by: cookies.get("email"),
      created_by: cookies.get("email"),
      schema_id: props.schema,
    };
    this.handleshowComputeModal = this.handleshowComputeModal.bind(this);
  }

  handleshowComputeModal = (e) => {
    this.setState({ showComputeModal: !this.state.showComputeModal });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ disableCompute: true });
    axios.post("api/transfer_to_stg_attendance/" + this.props.id, this.state).then((res) => {
      this.props.parentCallback(true);
      this.setState({ showComputeModal: false });
      this.setState({ disableCompute: false });
    });
  };

  render() {
    return (
      <>
        <button
          className="btn btn-outline-success btn-sm float-right"
          title="Transfer to staging"
          onClick={this.handleshowComputeModal}
        >
          <Check />
        </button>
        <Modal
          size="md"
          show={this.state.showComputeModal}
          onHide={() =>
            this.setState({ showComputeModal: !this.state.showComputeModal })
          }
        >
          <Modal.Header closeButton>
            <h4>Transfer timesheet to staging:<br/>{this.props.name}<br/>{this.props.period}</h4>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.handleSubmit} id="contact-form">
              <div className="row">
                <div className="form-group col-md-12 col-sm-12">
                  <label>Are you sure to Transfer timesheet to staging?</label>
                </div>
              </div>

              <div className="float-right">
                <button
                  disabled={this.state.disableCompute}
                  type="submit"
                  className="btn btn-primary btn-sm mr-2"
                >
                  Transfer {this.state.disableCompute ? <span class="spinner spinner-border spinner-border-sm" id="spinner" role="status" aria-hidden="true">
                    </span> : ""
                    }
                </button>
                <button
                  onClick={this.handleshowComputeModal}
                  className="btn btn-danger btn-sm"
                  type="button"
                >
                  Cancel
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
